import { useContext } from 'react'

import { Direction } from '@mui/material/styles'
import { MAP_LOCALE_DIRECTION } from '@src/Application/Constants/languageConstants'
import { Context } from '@src/Infrastructure/Context'

export const useGetThemeDirection = (): Direction => {
    const context = useContext(Context)

    return MAP_LOCALE_DIRECTION[context.locale]
}
